import React from "react";

import type { IconProps } from "./types";

const AiAgentInboxIcon: React.FC<IconProps> = ({ size = 30, stroke = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="7" y="8" width="16" height="14" rx="3" stroke={stroke} />
    <path
      d="M7 11.2L14.3784 15.6098C14.5629 15.7152 14.779 15.7714 15 15.7714C15.221 15.7714 15.437 15.7152 15.6216 15.6098L23 11.2"
      stroke={stroke}
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default AiAgentInboxIcon;
